import React, { useEffect, useState } from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { X } from 'lucide-react';
import { recentPurchases } from '../data/landing';
const FIRST_DELAY = 6000;
const VISIBLE_FOR = 5000;
const GAP = 12000;
export function FloatingNotification() {
  const [index, setIndex] = useState(0);
  const [visible, setVisible] = useState(false);
  const [dismissed, setDismissed] = useState(false);
  useEffect(() => {
    if (dismissed) return;
    let hideTimer: ReturnType<typeof setTimeout>;
    let showTimer: ReturnType<typeof setTimeout>;
    const show = (i: number, delay: number) => {
      showTimer = setTimeout(() => {
        setIndex(i);
        setVisible(true);
        hideTimer = setTimeout(() => {
          setVisible(false);
          show((i + 1) % recentPurchases.length, GAP);
        }, VISIBLE_FOR);
      }, delay);
    };
    show(0, FIRST_DELAY);
    return () => {
      clearTimeout(showTimer);
      clearTimeout(hideTimer);
    };
  }, [dismissed]);
  const purchase = recentPurchases[index];
  return <AnimatePresence data-id="element-60" data-mp="20vc1g2nugq2f">
      {visible && !dismissed && <motion.div key={purchase.name} initial={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} animate={{
      opacity: 1,
      y: 0,
      scale: 1
    }} exit={{
      opacity: 0,
      y: 16,
      scale: 0.96
    }} transition={{
      duration: 0.25,
      ease: [0.23, 1, 0.32, 1]
    }} role="status" className="fixed bottom-4 left-4 right-4 sm:right-auto z-40 sm:max-w-sm flex items-start gap-3 bg-white rounded-2xl border border-brand-purple/20 shadow-[0_10px_30px_rgba(23,61,31,0.2)] p-4 pr-10" data-id="element-61" data-mp="1vwqz9xp17wbc">
          <span className="w-10 h-10 rounded-full bg-brand-purpleDark flex items-center justify-center text-lg shrink-0" aria-hidden="true" data-id="element-62" data-mp="1887rdj9w9ljs">
            🌿
          </span>
          <div className="text-sm leading-snug" data-id="element-63" data-mp="z79l0ubzh1y1">
            <p className="text-[11px] font-semibold text-brand-greenMoss" data-id="element-64" data-mp="z5yggsaprq5v">
              🔔 Compra verificada · {purchase.ago}
            </p>
            <p className="mt-0.5 text-brand-text" data-id="element-65" data-mp="kjjcsuo6ued3">
              <strong className="text-brand-purpleDark" data-id="element-66" data-mp="kirh7julcgmt">{purchase.name}</strong>{' '}
              de {purchase.city} compró
            </p>
            <p className="font-medium text-brand-purple" data-id="element-67" data-mp="am4x4xa39tlu">
              Megapack Saberes Ancestrales · 5 volúmenes
            </p>
          </div>
          <button type="button" onClick={() => setDismissed(true)} aria-label="Cerrar notificación" className="absolute top-2 right-2 p-1.5 rounded-full text-brand-muted hover:text-brand-purpleDark hover:bg-brand-surfaceLight transition-colors duration-150" data-id="element-68" data-mp="flhtc8muod13">
            <X className="w-4 h-4" data-id="element-69" data-mp="timx21z3czt6" />
          </button>
        </motion.div>}
    </AnimatePresence>;
}